/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_Event_RequiredInputs */



/**
* | output |
* | --- |
* | "Name the event that starts this agent." |
*
* @param {Agent_Event_Trigger_Event_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_event_required = /** @type {((inputs?: Agent_Event_Trigger_Event_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Event_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benennen Sie das Ereignis, das diesen Agenten startet.")
	return /** @type {LocalizedString} */ ("Name the event that starts this agent.")
});